import React from "react";

export default function PlanCodeCard() {
  return (
    <div className="book">
      <p>Hello</p>
      <div className="cover">
        <p>Hover Me</p>
      </div>
    </div>
  );
}
